import React from "react";
import PageHeading from "../../Components/PageHeading/PageHeading";
import HowItWorksDropdown from "../HowItWorks/HowItWorksDropdown";
import { useNavigate } from "react-router-dom";
import ContentConsultant from "./ContentConsultant";
import ContentComic from "./ContentComic";
import ContentImage from "./ContentImage";
import ContentNews from "./ContentNews";
import ContentPost from "./ContentPost";
import ContentText from "./ContentText";
// import ContentTextVideo from "./ContentTextVideo";
import ContentDeveloper from "./ContentDeveloper";
import ContentToy from "./ContentToy";
import ContentVoice from "./ContentVoice";
import ContentPhotoPostAi from "./ContentPhotoPostAi";
import ContentPhotoPosterAi from "./ContentPhotoPosterAi";
import ContentBusinessPlan from "./ContentBusinessPlan";
import ContentProductVideoAi from "./ContentProductVideoAi";
import ContentFactOfTheDay from "./ContentFactOfTheDay";
import ContentMarketingPoster from "./ContentMarketingPoster";
import ContentVideoAi from "./ContentVideoAi";

const Gallery = () => {
  const [tabValue, setTabValue] = React.useState(0);
  const handleChangeTab = (event, newValue) => {
    setTabValue(newValue);
  };

  const navigate = useNavigate();

  const handleNavigate = () => {
    if (tabValue === 0) navigate('/business-plan-ai')
    else if (tabValue === 1) navigate('/comic-video-ai')
    else if (tabValue === 2) navigate('/social-media-consultant')
    // else if (tabValue === 3) navigate('/developer-ai')
    else if (tabValue === 4) navigate('/image-ai')
    else if (tabValue === 5) navigate('/promo-campaign-ai')
    // else if (tabValue === 5) navigate('/news-video-ai')
    else if (tabValue === 6) navigate('/social-post-ai')
    else if (tabValue === 7) navigate('/poster-design-ai')
    else if (tabValue === 8) navigate('/product-video-ai')
    // else if (tabValue === 8) navigate('/post-ai')
    else if (tabValue === 9) navigate('/video-ai')
    else if (tabValue === 10) navigate('/text-ai')
    // else if (tabValue === 10) navigate('/text-video-ai')
    else if (tabValue === 11) navigate('/toy-stories-ai')
    else if (tabValue === 12) navigate('/voice-ai')

  }

  return (
    <div>
      <PageHeading title="contents" />
      <div className="container account-container pb-3">

        <HowItWorksDropdown tabValue={tabValue} handleChangeTab={handleChangeTab} />

        <div
          // style={{ marginBlock: "20px", height: "200px", width: "100%" }}
          className="d-flex justify-content-center mt-2"
        >
          <button
            onClick={handleNavigate}
            className="btn btn-warning px-2 py-1">You can create similar contents. Click here.</button>
        </div>

        <div className="container mt-5 px-5">
          {tabValue === 0 && <ContentBusinessPlan />}

          {tabValue === 1 && <ContentComic />}

          {tabValue === 2 && <ContentConsultant />}

          {tabValue === 3 && <ContentFactOfTheDay />}

          {/* {tabValue === 3 && <ContentDeveloper />} */}

          {tabValue === 4 && <ContentImage />}

          {tabValue === 5 && <ContentMarketingPoster />}

          {/* {tabValue === 5 && <ContentNews />} */}

          {tabValue === 6 && <ContentPhotoPostAi />}

          {tabValue === 7 && <ContentPhotoPosterAi />}

          {tabValue === 8 && <ContentProductVideoAi />}

          {/* {tabValue === 8 && <ContentPost />} */}

          {tabValue === 9 && <ContentVideoAi />}

          {tabValue === 10 && <ContentText />}

          {/* {tabValue === 10 && <ContentTextVideo />} */}

          {tabValue === 11 && <ContentToy />}

          {tabValue === 12 && <ContentVoice />}

        </div>
      </div>
    </div>
  );
};

export default Gallery;
